/**
 * Performance Optimizer
 * Reduces main-thread work and optimizes resource loading
 */

(function() {
  'use strict';
  
  // Only run optimizations after page is interactive
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    requestIdleCallback(init, { timeout: 1000 });
  }
  
  function init() {
    optimizeImages();
    optimizeCSS();
    optimizeJavaScript();
    reduceMainThreadWork();
  }
  
  // Optimize image loading
  function optimizeImages() {
    // Use Intersection Observer for better lazy loading
    if ('IntersectionObserver' in window) {
      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            
            // Add decoding="async" if not present
            if (!img.hasAttribute('decoding')) {
              img.decoding = 'async';
            }
            
            // Remove from observer once loaded
            observer.unobserve(img);
          }
        });
      }, {
        rootMargin: '50px 0px',
        threshold: 0.01
      });
      
      // Observe all lazy images
      document.querySelectorAll('img[loading="lazy"]').forEach(img => {
        imageObserver.observe(img);
      });
    }
    
    // Optimize image sizes for mobile
    if (window.innerWidth <= 749) {
      const images = document.querySelectorAll('img[srcset]');
      images.forEach(img => {
        // Ensure mobile-optimized sizes
        if (!img.hasAttribute('sizes') || img.sizes.includes('100vw')) {
          // Keep existing sizes, but ensure mobile-first
        }
      });
    }
  }
  
  // Optimize CSS loading
  function optimizeCSS() {
    // Defer non-critical CSS
    const nonCriticalCSS = document.querySelectorAll('link[rel="stylesheet"]:not([media="print"])');
    nonCriticalCSS.forEach(link => {
      const href = link.href;
      // Skip critical CSS files
      if (href.includes('base.css') || href.includes('custom.css')) {
        return;
      }
      
      // Make non-critical CSS load asynchronously
      if (!link.hasAttribute('media')) {
        link.media = 'print';
        link.onload = function() {
          this.media = 'all';
        };
      }
    });
  }
  
  // Optimize JavaScript execution
  function optimizeJavaScript() {
    // Defer non-critical scripts
    const scripts = document.querySelectorAll('script[src]:not([defer]):not([async])');
    scripts.forEach(script => {
      const src = script.src;
      // Skip critical scripts
      if (src.includes('constants.js') || 
          src.includes('pubsub.js') || 
          src.includes('global.js') ||
          src.includes('script-dependency-manager.js')) {
        return;
      }

      // Add defer to non-critical scripts
      script.defer = true;
    });
  }
  
  // Reduce main-thread work
// function reduceMainThreadWork() {
//    // Use requestIdleCallback for non-critical work
//    const heavyOperations = [
//      initializeAnimations,
//      initializeThirdPartyWidgets,
//      preloadBelowFoldImages
//    ];
    
//    heavyOperations.forEach(op => {
//      if (window.requestIdleCallback) {
//        requestIdleCallback(op, { timeout: 2000 });
//      } else {
//        setTimeout(op, 2000);
//      }
//    });
//  }
  
  // Initialize animations only when needed
  function initializeAnimations() {
    if (!document.querySelector('.animate--hover')) return;
    
    // Animations script is already loaded conditionally in theme.liquid
  }
  
  // Initialize third-party widgets with delay
  function initializeThirdPartyWidgets() {
    // Widgets are already handled in theme.liquid
  }
  
  // Preload images below the fold
  function preloadBelowFoldImages() {
    if ('IntersectionObserver' in window) {
      const preloadObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            if (img.dataset.src && !img.src) {
              img.src = img.dataset.src;
              img.removeAttribute('data-src');
            }
            preloadObserver.unobserve(img);
          }
        });
      }, {
        rootMargin: '200px 0px'
      });
      
      document.querySelectorAll('img[data-src]').forEach(img => {
        preloadObserver.observe(img);
      });
    }
  }
  
  // Optimize scroll performance
  let scrollTimeout;
  window.addEventListener('scroll', function() {
    if (scrollTimeout) {
      cancelAnimationFrame(scrollTimeout);
    }
    scrollTimeout = requestAnimationFrame(function() {
      // Scroll-based optimizations here
    });
  }, { passive: true });
  
  // Optimize resize performance
  let resizeTimeout;
  window.addEventListener('resize', function() {
    if (resizeTimeout) {
      clearTimeout(resizeTimeout);
    }
    resizeTimeout = setTimeout(function() {
      // Resize-based optimizations here
    }, 150);
  }, { passive: true });
})();
